module.exports = "https://static.wmbcdn.com/uniweb/images/6e3c78bb93ef8c7c1d9b689bcd0b5979.svg";